import { enumify, Enumify } from '@mews/enumify';

enum CompanyAccountCreditRatingBasicEnum {
    CreditOk = 'CreditOk',
    PaymentRequiredUpfront = 'PaymentRequiredUpfront',
    LocalDecisionRequired = 'LocalDecisionRequired',
}

function CompanyAccountCreditRatingBasic() {}
enumify<CompanyAccountCreditRatingBasicEnum, CompanyAccountCreditRatingBasicEnum>(
    CompanyAccountCreditRatingBasic,
    'CompanyAccountCreditRatingBasic',
    CompanyAccountCreditRatingBasicEnum
);

export default CompanyAccountCreditRatingBasic as unknown as Enumify<
    CompanyAccountCreditRatingBasicEnum,
    CompanyAccountCreditRatingBasicEnum
>;
